import type React from 'react';
import { Layout } from './Layout';

interface ExpiredSessionViewProps {
  meetingId: string;
  onSignIn: () => void;
  onBack: () => void;
}

export const ExpiredSessionView: React.FC<ExpiredSessionViewProps> = ({
  meetingId,
  onSignIn,
  onBack,
}) => (
  <Layout>
    <h1 id="sign-in-required-title" className="sign-in-required__title">
      Joining meeting
    </h1>
    <p className="sign-in-required__meeting-id">Meeting ID: {meetingId}</p>
    <p className="sign-in-required__description">
      Your login session has expired. For security reasons, you need to sign in again to continue.
    </p>
    <div className="sign-in-required__actions">
      <button
        type="button"
        onClick={onSignIn}
        className="sign-in-required__button sign-in-required__button--primary"
      >
        Sign In
      </button>
      <button
        type="button"
        onClick={onBack}
        className="sign-in-required__button sign-in-required__button--text"
      >
        Back to Home
      </button>
    </div>
  </Layout>
);
